// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2rM3M","form":"styles_form__1wW5K"};